import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var CheckCircleOutline = function CheckCircleOutline(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9893 23.3516C18.0801 23.3516 23.1074 18.3242 23.1074 12.2441C23.1074 6.16406 18.0693 1.13672 11.9785 1.13672C5.89844 1.13672 0.881836 6.16406 0.881836 12.2441C0.881836 18.3242 5.90918 23.3516 11.9893 23.3516ZM11.9893 21.1387C7.05859 21.1387 3.11621 17.1748 3.11621 12.2441C3.11621 7.31348 7.05859 3.36035 11.9785 3.36035C16.9092 3.36035 20.873 7.31348 20.8838 12.2441C20.8945 17.1748 16.9199 21.1387 11.9893 21.1387ZM10.8291 17.3574C11.2266 17.3574 11.5596 17.1641 11.7852 16.8096L16.6299 9.26855C16.7803 9.04297 16.8984 8.78516 16.8984 8.54883C16.8984 8.01172 16.4258 7.64648 15.9102 7.64648C15.5879 7.64648 15.2979 7.8291 15.0723 8.19434L10.7969 15.0264L8.79883 12.4912C8.54102 12.1582 8.2832 12.0508 7.97168 12.0508C7.43457 12.0508 7.01562 12.4697 7.01562 13.0068C7.01562 13.2646 7.1123 13.501 7.29492 13.7373L9.83008 16.8203C10.1201 17.1855 10.4316 17.3574 10.8291 17.3574Z"
  })));
};

CheckCircleOutline.displayName = 'CheckCircleOutline';
export default CheckCircleOutline;